import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';

const styles = {
    jetRequirementsContainer: {
        overflowX: 'scroll',
    },
};

class jetNetworkTable extends Component {
    render() {
        const { classes } = this.props;

        return (
            <div className={classes.jetRequirementsContainer}>
                <table>
                    <thead>
                        <td>
                            <strong>Protocol</strong>
                        </td>
                        <td>
                            <strong>Direction</strong>
                        </td>
                        <td>
                            <strong>Port Range</strong>
                        </td>
                        <td>
                            <strong>Change Type</strong>
                        </td>
                        <td>
                            <strong>Description</strong>
                        </td>
                    </thead>
                    <tr>
                        <td>TCP</td>
                        <td>Inbound</td>
                        <td>49221</td>
                        <td>Network Firewall</td>
                        <td>Used for file transfer</td>
                    </tr>
                    <tr>
                        <td>UDP</td>
                        <td>Bidirectional</td>
                        <td>49221-49421</td>
                        <td>Network Firewall</td>
                        <td>Used for file transfer</td>
                    </tr>
                    <tr>
                        <td>TCP</td>
                        <td>Bidirectional</td>
                        <td>50221</td>
                        <td>Network Firewall</td>
                        <td>Used for file transfer</td>
                    </tr>
                    <tr>
                        <td>TCP</td>
                        <td>Outbound</td>
                        <td>443</td>
                        <td>Network Firewall</td>
                        <td>
                            Used to connect to cloud services:
                            <br /> Storage server to{' '}
                            <a href="https://ip-ranges.cloud.signiant.com/SDCX">Amazon EC2 IP Ranges</a>
                            <br /> Storage server to{' '}
                            <a href="https://ip-ranges.amazonaws.com/ip-ranges.json">Amazon CloudFront IP Ranges</a>
                        </td>
                    </tr>
                </table>
                <strong>Note</strong>: Port 443 requires unrestricted outbound access to the Internet. SDCX server
                versions 3.5 or earlier require TCP Port 80 to accept bidirectional traffic.
                <br />
                <br />
            </div>
        );
    }
}

export default withStyles(styles)(jetNetworkTable);
